import Button, { type ButtonProps } from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import SvgIcon from '@mui/material/SvgIcon'
import Tooltip from '@mui/material/Tooltip'
import { Reply } from '@styled-icons/heroicons-outline/Reply'
import noop from 'lodash/noop'
import React, { useCallback } from 'react'

import T from 'T'

import './style.scss'

type FooterButtonProps = {
  onProceed: () => void
  onBack?: () => void
  onClose: () => void
  leftButtonTitle?: string
  backButtonTitle?: string
  rightButtonTitle?: string
  disabledProceed?: boolean
  hasBackButton?: boolean
  hasProceedButton?: boolean
  disabledCancel?: boolean
  disabledBack?: boolean
  isProceedButtonMUIType?: boolean
  proceedButtonType?: 'button' | 'submit' | 'reset'
  tooltipTitle?: string
  showBackIcon?: boolean
  isProceedButtonLoading?: boolean
}

const FooterButton: React.FC<FooterButtonProps> = ({
  onProceed,
  onBack = noop,
  onClose,
  leftButtonTitle = T.CANCEL,
  backButtonTitle = T.BACK,
  rightButtonTitle = T.SAVE,
  disabledProceed = false,
  hasBackButton = false,
  hasProceedButton = true,
  disabledCancel = false,
  disabledBack = false,
  isProceedButtonMUIType = false,
  proceedButtonType = 'button',
  tooltipTitle = '',
  showBackIcon = true,
  isProceedButtonLoading = false,
}) => {
  const buttonProceedClass = disabledProceed ? 'btn-inactive' : 'btn-active'
  const buttonProceedCursorClass = disabledProceed ? 'cursor-not-allowed' : 'cursor-pointer'

  const handleBackClick = useCallback(() => {
    if (!disabledBack) onBack()
  }, [disabledBack, onBack])

  return (
    <>
      <Button
        color={'textSecondary' as ButtonProps['color']}
        disabled={disabledCancel}
        size="small"
        sx={{ mr: 2 }}
        variant="text"
        onClick={onClose}
      >
        {leftButtonTitle}
      </Button>
      {(hasBackButton || hasProceedButton) && (
        <Stack alignItems="center" flexDirection="row">
          {hasBackButton && (
            <Button
              color={'textSecondary' as ButtonProps['color']}
              size="small"
              startIcon={
                showBackIcon && (
                  <SvgIcon inheritViewBox sx={{ fontSize: 8 }}>
                    <Reply />
                  </SvgIcon>
                )
              }
              sx={{ mr: 2 }}
              variant="outlined"
              onClick={handleBackClick}
            >
              {backButtonTitle}
            </Button>
          )}

          {hasProceedButton &&
            (isProceedButtonMUIType ? (
              <Tooltip arrow placement="left" title={tooltipTitle}>
                <span className={buttonProceedCursorClass}>
                  <Button
                    disabled={disabledProceed}
                    loading={isProceedButtonLoading}
                    sx={{ height: 32 }}
                    variant="contained"
                    onClick={onProceed}
                  >
                    {rightButtonTitle}
                  </Button>
                </span>
              </Tooltip>
            ) : (
              <input
                className={`footer-btns footer-proceed ${buttonProceedClass}`}
                disabled={disabledProceed}
                type={proceedButtonType}
                value={rightButtonTitle}
                onClick={onProceed}
              />
            ))}
        </Stack>
      )}
    </>
  )
}

export default FooterButton
